import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";

const ArtistsIntro = ({ subtitle, title, smallText, bigText }) => {
  return (
    <Row className="d-flex bigger-margin-top justify-content-center bigger-margin-bottom">
      <Col
        xs={12}
        lg={8}
        className="d-flex flex-column justify-content-center align-items-center text-center"
      >
        {subtitle && <p className="fs-5">{subtitle}</p>}
        {title && <h2 className="text-white mb-5 h1">{title}</h2>}
        {smallText && <p>{smallText}</p>}
        {bigText && <p style={{ whiteSpace: "pre-wrap" }}>{bigText}</p>}
      </Col>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
ArtistsIntro.contextTypes = {
  t: PropTypes.func,
};

ArtistsIntro.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string,
  smallText: PropTypes.string,
  bigText: PropTypes.string,
};

ArtistsIntro.defaultProps = {};

export default ArtistsIntro;
